export default __webpack_public_path__ + "static/media/sleepRentDoFacebook-1200x630.15673872.jpg";